import { PlusOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from 'src/components/v1/Breadcrumb';
import TicketFilterPopover from 'src/components/v2/Popover/TicketFilterPopover';
import { SearchTicket } from 'src/components/v2/Search';
import urlPath from 'src/constants/urlPath';
import { useBasePath } from 'src/hooks/useBasePath';
import TicketSortPopover from '../Popover/TicketSortPopover';

import AddLeavePackageModal from 'src/pages/v2/HrTicket/LeavePackage/AddLeavePackage';
import { getAddPath } from 'src/utils/utils';
import RaiseTicketModal from '../Button/RaiseTicketButton/RaiseTicketModal';
import './subHeader.scss';
// import { showNotification } from 'src/utils/notification';

export type TicketType = 'leave' | 'overtime' | 'businessTrip';

const SubHeader = ({ hasSubHeader }: { hasSubHeader?: boolean }) => {
  const location = useLocation();
  const basePath = useBasePath();
  const navigate = useNavigate();
  const [isOpenAddTicket, setIsOpenAddTicket] = useState<boolean>(false);
  const [isOpenAddLeavePackage, setIsOpenAddLeavePackage] = useState<boolean>(false);
  const [, setPath] = useState<string | undefined>('');

  // urlType logic
  const path = location.pathname;
  const urlType = useMemo(() => {
    if (path.includes('/additional-working-time-ticket/my-package')) return 'additional-working-time-package';
    if (path.includes('/leave-ticket/my-package')) return 'leave-package';
    if (path.includes('/approval-package')) return 'approval-package';
    if (path.includes('/my-package')) return 'my-package';
    return '';
  }, [path]);

  useEffect(() => {
    if (getAddPath(basePath)?.includes('/add') && !basePath?.includes(urlPath.solution.location)) {
      const index = getAddPath(basePath)?.indexOf('/add');
      setPath(getAddPath(basePath)?.slice(0, index));
    } else if (basePath?.includes('/edit')) {
      const index = basePath.indexOf('/edit');
      setPath(basePath.slice(0, index));
    } else {
      setPath('');
    }
  }, [basePath]);

  // Handler for add button
  const handleAdd = () => {
    if (urlType === 'leave-package') {
      setIsOpenAddLeavePackage(true);
      return;
    }
    // --- giữ nguyên logic cũ cho tạo ticket ---
    if (location.pathname.includes(urlPath.ticket.location)) {
      setIsOpenAddTicket(true);
    } else if (location.pathname.includes(urlPath.leaveTicket.location)) {
      navigate(urlPath.leaveTicketAdd.location);
    } else if (location.pathname.includes(urlPath.advancePaymentTicket.location)) {
      navigate(urlPath.advancePaymentTicketAdd.location);
    } else if (location.pathname.includes(urlPath.overtimeTicket.location)) {
      navigate(urlPath.overtimeTicketAdd.location);
    } else if (location.pathname.includes(urlPath.businessTripTicket.location)) {
      navigate(urlPath.businessTripTicketAdd.location);
    } else if (location.pathname.includes(urlPath.purchaseRequestTicket.location)) {
      navigate(urlPath.purchaseRequestTicketAdd.location);
    } else if (location.pathname.includes(urlPath.transportationTicket.location)) {
      navigate(urlPath.transportationTicketAdd.location);
    } else if (location.pathname.includes(urlPath.handoverTicket.location)) {
      navigate(urlPath.handoverTicketAdd.location);
    } else if (location.pathname.includes(urlPath.additionalWorkingTimeTicket.location)) {
      navigate(urlPath.additionalWorkingTimeTicketAdd.location);
    } else if (location.pathname.includes(urlPath.leaveTicketSub.location)) {
      navigate(urlPath.leaveTicketAddSub.location);
    } else if (location.pathname.includes(urlPath.resignationTicket.location)) {
      navigate(urlPath.resignationTicketAdd.location);
    } else if (location.pathname.includes(urlPath.resignationTicketSub.location)) {
      navigate(urlPath.resignationTicketAddSub.location);
    }
  };

  const renderSearchElement = () => {
    if (
      !getAddPath(basePath)?.includes('/add') &&
      !location.pathname.includes('/edit') &&
      !location.pathname.includes(urlPath.biometricLog.location)
      // &&
      // !location.pathname.includes(urlPath.userGuides.location)
    ) {
      // Chỉ hiển thị nút ở trang my-ticket và các trang package
      const isMyTicket = location.pathname.includes('/my-ticket');
      const isMyAdditionalWorkingTimePackage = location.pathname.includes('/additional-working-time-ticket/my-package');
      const isMyLeavePackage = location.pathname.includes('/leave-ticket/my-package');
      return (
        <Flex justify='end' align='center' gap={20} className='panel-search'>
          <Flex justify='end' style={{ width: '70%' }}>
            <TicketFilterPopover />
          </Flex>
          <Flex>
            <TicketSortPopover />
          </Flex>
          <Flex>
            <SearchTicket placeholder='Nhập mã phiếu hoặc người tạo' className='sub-header-search' />
          </Flex>
          {(isMyTicket || isMyAdditionalWorkingTimePackage || isMyLeavePackage) && (
            <Button type='primary' icon={<PlusOutlined />} className='create-ticket-btn' onClick={handleAdd}>
              Tạo
            </Button>
          )}
        </Flex>
      );
    }
  };

  return (
    <div className='sub-header-ticket'>
      <Flex justify='space-between' align='middle' gap={10} className='sub-header-row'>
        <div className='sub-header-col panel-navigation'>
          <div className='menu-button'>
            <Breadcrumb className='breadcrumb' />
          </div>
        </div>
        <Flex align='center' gap={10}>
          {hasSubHeader && renderSearchElement()}
        </Flex>
      </Flex>
      {isOpenAddTicket && <RaiseTicketModal setIsOpen={setIsOpenAddTicket} isOpen={isOpenAddTicket} />}
      {/* Modal tạo package */}
      <AddLeavePackageModal
        visible={isOpenAddLeavePackage}
        onCancel={() => setIsOpenAddLeavePackage(false)}
        onSuccess={() => setIsOpenAddLeavePackage(false)}
      />
    </div>
  );
};

export default SubHeader;
